import { HTTP } from '@/http'
import idb from '@/idb'

const cacheBoardLogos = async logos => {
  let logosToCache = Object.values(logos || {}).filter(logo => logo.ok && logo.version)
  if (logosToCache.length === 0) return

  try {
    await HTTP.post('/api/board-logos/cache', { logos: logosToCache })
  } catch (e) {
    // Недоступный кэш логотипов не должен мешать отображению табло.
  }
}
// initial state
const state = {
  arrivalBoard: {},
  departureBoard: {},
  arrivalDate: '',
  departureDate: '',
  arrivalPreloader: true,
  departurePreloader: true,
}
// mutations
const mutations = {
  setArrivalBoard: function(state, val) {
    state.arrivalBoard = val
  },
  setArrivalDate: function(state, val) {
    state.arrivalDate = val
  },
  setDepartureBoard: function(state, val) {
    state.departureBoard = val
  },
  setDepartureDate: function(state, val) {
    state.departureDate = val
  },
  setArrivalPreloaderState: function(state, value) {
    state.arrivalPreloader = value
  },
  setDeparturePreloaderState: function(state, value) {
    state.departurePreloader = value
  },
}
// actions
const actions = {
   async updateBoards(context) {
    let access = context.rootGetters.chechAccess('visin')
    if (!access) {
      context.commit('setArrivalPreloaderState', false)
      context.commit('setDeparturePreloaderState', false)
      return false
    }

    context.commit('setArrivalPreloaderState', true)
    context.commit('setDeparturePreloaderState', true)

    let cachedLogos = await idb.getLogos()
    cachedLogos = cachedLogos[0] || null
    if (cachedLogos && Object.keys(cachedLogos).length === 0) {
      cachedLogos = null
    }

    let cachedLogosForRequest = cachedLogos && JSON.parse(JSON.stringify(cachedLogos))
    if (cachedLogosForRequest) {
      Object.keys(cachedLogosForRequest).forEach(k => {
        delete cachedLogosForRequest[k]['logo']
      })
    }

    try {
      let response = await HTTP.post('/api/boards', {
        arrivalDate: context.getters.getArrivalDate || null,
        departureDate: context.getters.getDepartureDate || null,
        logos: cachedLogosForRequest,
      })

      if (response.status === 200) {
        await cacheBoardLogos(response.data.logoCache || response.data.logos)
        cachedLogos = cachedLogos || {}
        Object.keys(response.data.logos).forEach(k => {
          cachedLogos[k] = response.data.logos[k]
        })
        idb.saveLogos(cachedLogos)

        let arrival = response.data.arrival.map(board => ({
          ...board,
          logo: cachedLogos[board['Airline']]?.['logo'] || null,
        }))
        let departure = response.data.departure.map(board => ({
          ...board,
          logo: cachedLogos[board['Airline']]?.['logo'] || null,
        }))

        let arrivalBoards = { ...context.getters.getArrivalBoard('') }
        let departureBoards = { ...context.getters.getDepartureBoard('') }
        arrivalBoards[context.getters.getArrivalDate || 'current'] = arrival
        departureBoards[context.getters.getDepartureDate || 'current'] = departure
        context.commit('setArrivalBoard', arrivalBoards)
        context.commit('setDepartureBoard', departureBoards)
      }
    } catch (e) {
      this.errorMessage = e
      this.dispatch('errorProcess', e)
    } finally {
      context.commit('setArrivalPreloaderState', false)
      context.commit('setDeparturePreloaderState', false)
    }
  },
   async updateArrivalBoard(context) {
    let access = context.rootGetters.chechAccess('visin')
    if (!access) {
      context.commit('setArrivalPreloaderState', false)
      return false
    }
    context.commit('setArrivalPreloaderState', true)

    let date = context.getters.getArrivalDate || null

    let cachedLogos = await idb.getLogos()
    cachedLogos = cachedLogos[0] || null
    if (cachedLogos) {
      if (Object.keys(cachedLogos).length === 0) {
        cachedLogos = null
      }
    }

    let cachedLogosForRequest = cachedLogos && JSON.parse(JSON.stringify(cachedLogos))

    if (cachedLogosForRequest) {
      Object.keys(cachedLogosForRequest).forEach(k => {
        delete cachedLogosForRequest[k]['logo']
      })
    }

     await HTTP.post('/api/arrival-board', { date: date, logos: cachedLogosForRequest })
      .then(async response => {
        if (response.status === 200) {
          let res = { ...context.getters.getArrivalBoard('') }
          let boards = [...response.data.boards]
          let logos = Object.assign({}, response.data.logos)
          await cacheBoardLogos(response.data.logoCache || logos)

          if (!cachedLogos) {
            cachedLogos = logos
          } else {
            Object.keys(logos).forEach(k => {
              cachedLogos[k] = logos[k]
            })
          }

          idb.saveLogos(cachedLogos)

          boards = boards.map(function(board) {
            let airline = board['Airline']
            return { ...board, logo: cachedLogos[airline]?.['logo'] }
          })

          res[date || 'current'] = boards
          context.commit('setArrivalBoard', res)
        }
      })
      .catch(e => {
        this.errorMessage = e
        this.dispatch('errorProcess', e)
      })
    context.commit('setArrivalPreloaderState', false)
  },
   async  updateDepartureBoard(context) {
    let access = context.rootGetters.chechAccess('visin')
    if (!access) {
      context.commit('setDeparturePreloaderState', false)
      return false
    }
    context.commit('setDeparturePreloaderState', true)

    let date = context.getters.getDepartureDate || null

    let cachedLogos =  await idb.getLogos()
    cachedLogos = cachedLogos[0] || null
    if (cachedLogos) {
      if (Object.keys(cachedLogos).length === 0) {
        cachedLogos = null
      }
    }

    let cachedLogosForRequest = cachedLogos && JSON.parse(JSON.stringify(cachedLogos))

    if (cachedLogosForRequest) {
      Object.keys(cachedLogosForRequest).forEach(k => {
        delete cachedLogosForRequest[k]['logo']
      })
    }

     await HTTP.post('/api/departure-board', { date: date, logos: cachedLogosForRequest })
      .then(async response => {
        if (response.status === 200) {
          let res = { ...context.getters.getDepartureBoard('') }
          let boards = [...response.data.boards]
          let logos = Object.assign({}, response.data.logos)
          await cacheBoardLogos(response.data.logoCache || logos)

          if (!cachedLogos) {
            cachedLogos = logos
          } else {
            Object.keys(logos).forEach(k => {
              cachedLogos[k] = logos[k]
            })
          }

          idb.saveLogos(cachedLogos)

          boards = boards.map(function(board) {
            let airline = board['Airline']
            if(airline)
              return { ...board, logo: cachedLogos[airline]['logo'] }
            else
              return { ...board, logo: null }
          })

          res[date || 'current'] = boards
          context.commit('setDepartureBoard', res)
          context.commit('setDeparturePreloaderState', false)
        }
      })
      .catch(e => {
        this.errorMessage = e
        this.dispatch('errorProcess', e)
        context.commit('setDeparturePreloaderState', false)
      })

  },
}
// getters
const getters = {
  getDepartureBoard: state => key => {
    if (key) {
      return state.departureBoard[key]
    } else {
      return state.departureBoard
    }
  },
  getArrivalBoard: state => key => {
    if (key) {
      return state.arrivalBoard[key]
    } else {
      return state.arrivalBoard
    }
  },
  getArrivalPreloader(state) {
    return state.arrivalPreloader
  },
  getDeparturePreloader(state) {
    return state.departurePreloader
  },
  getArrivalDate(state) {
    return state.arrivalDate
  },
  getDepartureDate(state) {
    return state.departureDate
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
